var _style, _rect, _polyline, _g, _g2, _g3, _g4, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 280 100",
    width: 280,
    height: 100,
    style: {
      enableBackground: "new 0 0 280 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:transparent;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{enable-background:new    ;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -6.3,
    y: -13.7,
    className: "st0",
    width: 294,
    height: 120.6
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "190.5,81.2 253.5,18.2 264.4,18.5 201.1,81.2 190.5,81.2 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "229,42.8 223.6,48.2 256.6,81.2 267.5,81  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "219.4,33.4 204.2,18.2 193.6,18.2 214.1,38.7  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.4,52.4c0,3.6-3,6.6-6.6,6.6h-8.3c-3.1,0-5.8-2.2-6.5-5.2h4.1c0.5,0.8,1.4,1.4,2.4,1.4h8.3 c1.5,0,2.8-1.2,2.8-2.8v-0.1c0-1.5-1.2-2.8-2.8-2.8h-8.3c-3.6,0-6.6-3-6.6-6.6v-0.1c0-3.6,3-6.6,6.6-6.6h8.3c3.1,0,5.8,2.2,6.5,5.2 h-4c-0.5-0.9-1.4-1.4-2.4-1.4h-8.3c-1.5,0-2.8,1.2-2.8,2.8V43c0,1.5,1.2,2.8,2.8,2.8h8.3C33.5,45.8,36.4,48.7,36.4,52.4L36.4,52.4 L36.4,52.4z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.6,40.7h-8.1V59h-4.4V40.7h-8.1v-4.4h20.6V40.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M83.2,59h-4.4c-0.1-1-0.4-1.9-0.8-2.8c-1.2-2.7-3.8-4.5-6.6-4.7c-0.4,0-1,0-1.7,0c-0.3,0-0.6,0-0.8,0h-3.2V59 h-4.4V36.4h0.3v-0.1h14c4.2,0,7.6,3.4,7.6,7.6c0,2.3-1,4.5-2.9,5.9l-1.1,0.9l0.9,1.1C81.8,53.9,82.9,56.4,83.2,59z M79.3,43.9 c0-2.1-1.7-3.7-3.7-3.7h-9.9v7.5h9.9C77.6,47.6,79.3,46,79.3,43.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90.3,46h13.1v3.4H90.3v6.2h14.5V59H85.9V36.3h18.9v3.4H90.3V46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M129.8,59h-7.2l-10.7-19.6V59h-4.4V36.3h7.7L125.4,55V36.3h4.4V59z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M137,51.3c0,1.9,1.5,3.4,3.4,3.4h8.6v-7.3h4.4V59h-13c-4.3,0-7.8-3.5-7.8-7.8v-7.2c0-4.3,3.5-7.8,7.8-7.8h13 v4.4h-13c-1.9,0-3.4,1.5-3.4,3.4V51.3z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M176.1,40.7H168V59h-4.4V40.7h-8.1v-4.4h20.6V40.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M198.7,59h-4.4v-9.4h-11.4V59h-4.4V36.3h4.4v9.4h11.4v-9.4h4.4V59z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4bd675c8fad837b82440dcee1b074dc8.svg";
export { ForwardRef as ReactComponent };